import React from "react";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        <div className="static-header">
          <h1 className="container">Terms and Conditions</h1>
        </div>
        <div className="container mt-3">
          <p>
            <b>Effective Date: </b> August 5, 2025
            <br />
          </p>
          <p className="mb-4">
            Welcome to UpskillMeet, operated by <b>AVANAD TECHPROSERVE</b>{" "}
            ("Company," "we," "our," or "us"). These Terms and Conditions
            ("Terms") govern your use of our platform, which includes our
            website, applications, products, and services (collectively, the
            "Platform"). By accessing or using the Platform, you agree to be
            bound by these Terms. If you do not agree, please do not access or
            use the Platform.
          </p>
          <hr />
        </div>

        <div className="container">
          <p>
            <b>1. Eligibility</b>
          </p>
          <p>
            Our services are open to users of all ages, including students.
            However, if you are under 18 years of age, you must use the Platform
            under the supervision of a parent or legal guardian. By accessing or
            using the Platform, you represent and warrant that you have the
            appropriate permissions or supervision to do so.
          </p>
          <hr />

          <p>
            <b>2. User Registration & Account</b>
          </p>
          <p>
            To use certain features of the Platform, you may be required to
            register and provide accurate, complete information including (but
            not limited to):
          </p>
          <ul>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Phone Number (for internal use only)</li>
            <li>WhatsApp Number (for internal use only)</li>
            <li>Educational Qualifications (optional)</li>
            <li>Work Experience Details (optional)</li>
            <li>Social Media Profiles (optional)</li>
            <li>
              Bank Account Details (only for service providers offering paid
              sessions)
            </li>
            <li>
              Google Calendar integration (optional, for session scheduling)
            </li>
          </ul>
          <p>
            You agree to maintain the confidentiality of your account
            credentials and are responsible for all activities under your
            account.
          </p>
          <hr />

          <p>
            <b>3. License to Use the Platform</b>
          </p>
          <p>
            We grant you a limited, non-exclusive, non-transferable, revocable
            license to use the Platform strictly in accordance with these Terms.
            You may not:
          </p>
          <ul>
            <li>Reverse engineer or copy any part of the Platform</li>
            <li>Redistribute content without authorization</li>
            <li>Use the Platform for any unlawful purpose</li>
          </ul>
          <hr />

          <p>
            <b>4. User Conduct</b>
          </p>
          <p>You agree not to:</p>
          <ul>
            <li>Violate any applicable laws or regulations</li>
            <li>Impersonate another person or entity</li>
            <li>Upload offensive, abusive, or harmful content</li>
            <li>Infringe on any intellectual property rights</li>
            <li>Engage in unauthorized commercial advertising</li>
          </ul>
          <p>
            Violation of this section may result in suspension or termination of
            your account.
          </p>
          <hr />

          <p>
            <b>5. Use of Personal Data</b>
          </p>
          <p>
            We collect and use your personal data in accordance with our Privacy
            Policy. Data you provide, including name, email, phone number,
            education, experience, and payment information, may be used to
            improve our services and facilitate transactions.
          </p>
          <p>
            Sensitive information such as your WhatsApp number, phone number,
            and bank details will only be used internally and will not be
            displayed publicly on the Platform.
          </p>
          <p>
            Your data is securely stored on our servers and protected using
            industry-standard encryption and access control mechanisms to ensure
            its safety and confidentiality.
          </p>
          <hr />

          <p>
            <b>6. Third-Party Services</b>
          </p>
          <p>
            We use third-party services to process payments (e.g., Razorpay) and
            enable calendar scheduling (Google Calendar). By using our Platform,
            you also agree to the respective terms and privacy policies of these
            providers.
          </p>
          <p>
            We are not responsible for any data or transaction issues that arise
            from these third-party services.
          </p>
          <hr />

          <p>
            <b>7. Intellectual Property</b>
          </p>
          <p>
            All content, logos, trademarks, and data on the Platform are the
            property of AVANAD TECHPROSERVE or its licensors. You may not
            reproduce, modify, or distribute any content without express written
            permission.
          </p>
          <hr />

          <p>
            <b>8. Indemnity</b>
          </p>
          <p>
            You agree to indemnify, defend, and hold harmless AVANAD
            TECHPROSERVE, its affiliates, officers, employees, and agents from
            any claim, liability, loss, or expense arising from:
          </p>
          <ul>
            <li>Your use or misuse of the Platform</li>
            <li>Your violation of these Terms</li>
            <li>Any content submitted by you</li>
          </ul>
          <hr />

          <p>
            <b>9. Modifications to Terms</b>
          </p>
          <p>
            We may update these Terms from time to time. When we do, we will
            revise the "Effective Date" at the top. Continued use of the
            Platform after any such changes constitutes your acceptance of the
            new Terms.
          </p>
          <hr />

          <p>
            <b>10. Termination</b>
          </p>
          <p>
            We reserve the right to suspend or terminate your access to the
            Platform at our sole discretion, with or without notice, if you
            violate these Terms or applicable laws.
          </p>
          <hr />

          <p>
            <b>11. Disclaimers</b>
          </p>
          <p>
            The Platform is provided on an "as-is" basis. We make no warranties
            regarding availability, accuracy, or fitness for a particular
            purpose. We are not liable for any indirect, incidental, or
            consequential damages arising out of your use of the Platform.
          </p>
          <hr />

          <p>
            <b>12. Governing Law</b>
          </p>
          <p>
            These Terms are governed by the laws of India. Disputes shall be
            subject to the exclusive jurisdiction of the courts of Chennai,
            Tamil Nadu, India.
          </p>
          <hr />

          <p>
            <b>13. Grievance Officer</b>
          </p>
          <p>
            If you have any complaints or concerns, please contact our
            designated Grievance Officer:
          </p>
          <p>
            Name: Grievance Officer - AVANAD TECHPROSERVE
            <br />
            Email:{" "}
            <a href="mailto:contactus@techproserve.com">
              contactus@techproserve.com
            </a>
            <br />
            Address: G2-F1, VGN Minerva, Nolambur, Mogappair West, Chennai -
            600095, India
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
